module.exports = __webpack_public_path__ + "static/media/consultation_message_bg.44ad7683.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_message_bg.png
// module id = 579
// module chunks = 0